(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1698,2201],{

/***/ 3137:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careers",
      function () {
        return __webpack_require__(97234);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_Home_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81673);
/* harmony import */ var _styles_Home_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_Home_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31555);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45992);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70710);











const KcNews = (props)=>{
    const data = props.homePageData;
    const sliderSettings = {
        dots: true,
        dotsClass: (_styles_Home_module_scss__WEBPACK_IMPORTED_MODULE_7___default().kcNewsSliderDots),
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 2,
        slidesPerRow: 4,
        arrows: false,
        responsive: [
            {
                breakpoint: 850,
                settings: {
                    slidesPerRow: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesPerRow: 2
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: (_styles_Home_module_scss__WEBPACK_IMPORTED_MODULE_7___default().kcNews),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_Home_module_scss__WEBPACK_IMPORTED_MODULE_7___default().heading),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: data?.kcNewsTitle
                            }),
                            data?.kcNewsSubTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: data.kcNewsSubTitle
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        ...sliderSettings,
                        children: data?.kcNews?.length > 0 && data.kcNews.map((news, index)=>{
                            const image = news.image;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                className: `${(_styles_Home_module_scss__WEBPACK_IMPORTED_MODULE_7___default().col)} ${Math.floor(index / 4) % 2 !== 0 ? (_styles_Home_module_scss__WEBPACK_IMPORTED_MODULE_7___default().borderBottomMd) : ""} ${Math.floor(index / 3) % 2 !== 0 ? (_styles_Home_module_scss__WEBPACK_IMPORTED_MODULE_7___default().borderBottomSm) : ""} ${Math.floor(index / 2) % 2 !== 0 ? (_styles_Home_module_scss__WEBPACK_IMPORTED_MODULE_7___default().borderBottomXs) : ""}`,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: news.link,
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        className: (_styles_Home_module_scss__WEBPACK_IMPORTED_MODULE_7___default().img),
                                        src: image?.url,
                                        alt: image?.alternativeText,
                                        width: 175,
                                        height: 75
                                    })
                                })
                            }, index);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (KcNews);


/***/ }),

/***/ 70710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LazyReveal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
"use client";


const DefaultShimmer = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "animate-pulse bg-gray-300 h-6 w-full rounded-lg"
    });
function LazyReveal({ children , shimmer , rootMargin ="0px" , threshold =0.1 , className , onVisible , id , style  }) {
    const { 0: visible , 1: setVisible  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const observerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!wrapperRef.current) return;
        observerRef.current = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry.isIntersecting) {
                setVisible(true);
                onVisible && onVisible();
                observerRef.current?.disconnect();
            }
        }, {
            rootMargin,
            threshold
        });
        observerRef.current.observe(wrapperRef.current);
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, [
        rootMargin,
        threshold
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: className,
        id: id,
        style: style,
        children: visible ? children : shimmer || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DefaultShimmer, {})
    });
}


/***/ }),

/***/ 47046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MetaTagsComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59830);





const MetaTagsComp = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUrl = "https://staging.studies-overseas.com" + (router.asPath || "");
    const { metaTitle , metaDescription , src , keywords , robotsMeta , ogimage , twitterimage , isCustomSchema , schemaJson , jotforms , canonicalUrl , isBlogPage  } = props;
    const structuredJSON = isCustomSchema && schemaJson ? schemaJson : _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultSchema */ .R4;
    const removeQueryParameters = (url)=>{
        const currentUrl = url;
        const queryIndex = currentUrl.indexOf("?");
        return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
    };
    const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: metaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: metaDescription
                }),
                keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                robotsMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: robotsMeta
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "Organization"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: cleanCanonicalUrl || canonicalUrl
                }),
                src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: src
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: "@KCOverseasEdu"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: "@KCOverseasEdu"
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                structuredJSON && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    className: "structured-data-list",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredJSON)
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 55689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42547);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34051);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10682);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59830);
/* harmony import */ var _LazyMedia__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37462);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70710);













const VideoTestimonials = (props)=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const limitedTestimonials = props.testimonialVideos?.sort((firstVideoTestimonial, secondVideoTestimonial)=>secondVideoTestimonial.id - firstVideoTestimonial.id)?.slice(0, 15);
    const videosCount = props.testimonialVideos?.length || 0;
    const videosSlidersettings = {
        infinite: videosCount > 3,
        arrows: false,
        speed: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .sliderSpeed.desktopSpeed */ .Y$.desktopSpeed,
        slidesToShow: 3,
        slidesToScroll: 3,
        rows: 1,
        slidesPerRow: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                    infinite: videosCount > 2,
                    autoplay: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dotsClass: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sliderDots),
                    infinite: videosCount > 1,
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .sliderSpeed.mobileAutoplaySpeed */ .Y$.mobileAutoplaySpeed
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().achievements),
        style: {
            backgroundColor: props.sectionBgColor || "#ffffff",
            ...props?.parentContainerStyles ?? {}
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().containerDiv),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().heading),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: props.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().description),
                                children: props.subTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sliderContainer),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                ...videosSlidersettings,
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().slider),
                                ref: sliderRef,
                                children: limitedTestimonials?.length > 0 && limitedTestimonials?.map((content, index)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().achievementsDiv),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                    width: "33",
                                                    height: "22",
                                                    viewBox: "0 0 33 22",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M0.0267741 14.2441C0.0232465 14.3384 0.0214669 14.4331 0.0214669 14.5283C0.0214665 18.6548 3.36666 22 7.49316 22C11.6197 22 14.9648 18.6548 14.9648 14.5283C14.9648 10.4018 11.6197 7.05662 7.49316 7.05662C6.73028 7.05662 5.99411 7.17095 5.30084 7.38341C6.8185 4.06918 11.3775 1.11242 13.5805 1.32304e-05C2.06855 2.26919 -0.255979 10.4465 0.0207498 14.2516L0.0267741 14.2441Z",
                                                            fill: "#226CF5"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M18.0492 14.2439C18.0457 14.3382 18.0439 14.4331 18.0439 14.5283C18.0439 18.6548 21.3891 22 25.5156 22C29.6421 22 32.9873 18.6548 32.9873 14.5283C32.9873 10.4018 29.6421 7.05662 25.5156 7.05662C24.7527 7.05662 24.0164 7.17097 23.3231 7.38347C24.8408 4.06924 29.3998 1.11247 31.6028 6.47288e-05C20.0908 2.26924 17.7663 10.4466 18.043 14.2516L18.0492 14.2439Z",
                                                            fill: "#226CF5"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().videoDiv),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__.LazyLoadComponent, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyMedia__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                        iframeClassName: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().studVideo),
                                                        src: content.videoLink,
                                                        title: "YouTube video player",
                                                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().content),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                        children: content.name
                                                    }),
                                                    content?.designation ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: content.designation
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: content.university
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            }),
                            props.testimonialVideos?.length > 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().arrowsClass),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btcircle),
                                        onClick: ()=>sliderRef?.current?.slickPrev(),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            src: "/new-images/left-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "left-arrow"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btcircle),
                                        onClick: ()=>sliderRef?.current?.slickNext(),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            src: "/new-images/right-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "right-arrow"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VideoTestimonials);


/***/ }),

/***/ 97234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ careers; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/careerkc.module.scss
var careerkc_module = __webpack_require__(46577);
var careerkc_module_default = /*#__PURE__*/__webpack_require__.n(careerkc_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./styles/TechTestimonial.module.scss
var TechTestimonial_module = __webpack_require__(12776);
var TechTestimonial_module_default = /*#__PURE__*/__webpack_require__.n(TechTestimonial_module);
// EXTERNAL MODULE: ./utils/fetchUtil.ts
var fetchUtil = __webpack_require__(40607);
;// CONCATENATED MODULE: ./components/TectAtKcTestimonial.tsx












const TechTestimonial = ({ title , bgColor , slug , data  })=>{
    const sliderRef = (0,react.useRef)(null);
    const { 0: testimonialData , 1: setTestimonialData  } = (0,react.useState)({});
    const settings = {
        dotsClass: (TechTestimonial_module_default()).sliderDots,
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
    };
    (0,react.useEffect)(()=>{
        data ? setTestimonialData(data) : (0,fetchUtil/* default */.Z)(`${"https://cms-staging.studies-overseas.com"}/${slug}`, "GET", {}, "", false).then((res)=>setTestimonialData(res));
    }, []);
    return testimonialData?.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "studenttestimonial",
        className: (TechTestimonial_module_default()).studentTestSlider,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mb-5 text-center",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "studentmm",
                    className: (TechTestimonial_module_default()).student,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TechTestimonial_module_default()).customContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "justify-content-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    xl: 12,
                                    lg: 12,
                                    md: 10,
                                    sm: 12,
                                    xs: 12,
                                    className: "position-relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                            ...settings,
                                            ref: sliderRef,
                                            className: (TechTestimonial_module_default()).slider,
                                            children: testimonialData.map((slide, index)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                                        className: (TechTestimonial_module_default()).stuTestCard,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (TechTestimonial_module_default()).overlay
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                                                className: (TechTestimonial_module_default()).cardBody,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (TechTestimonial_module_default()).testimonialImage,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                            height: 180,
                                                                            width: 140,
                                                                            src: slide?.testimonial?.image?.url,
                                                                            alt: slide?.testimonial?.image?.alternativeText
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (TechTestimonial_module_default()).testimonialDetail,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                                width: "33",
                                                                                height: "22",
                                                                                viewBox: "0 0 33 22",
                                                                                fill: "none",
                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                        fillRule: "evenodd",
                                                                                        clipRule: "evenodd",
                                                                                        d: "M0.0267741 14.2441C0.0232465 14.3384 0.0214669 14.4331 0.0214669 14.5283C0.0214665 18.6548 3.36666 22 7.49316 22C11.6197 22 14.9648 18.6548 14.9648 14.5283C14.9648 10.4018 11.6197 7.05662 7.49316 7.05662C6.73028 7.05662 5.99411 7.17095 5.30084 7.38341C6.8185 4.06918 11.3775 1.11242 13.5805 1.32304e-05C2.06855 2.26919 -0.255979 10.4465 0.0207498 14.2516L0.0267741 14.2441Z",
                                                                                        fill: "#FDAF4D"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                        fillRule: "evenodd",
                                                                                        clipRule: "evenodd",
                                                                                        d: "M18.0492 14.2439C18.0457 14.3382 18.0439 14.4331 18.0439 14.5283C18.0439 18.6548 21.3891 22 25.5156 22C29.6421 22 32.9873 18.6548 32.9873 14.5283C32.9873 10.4018 29.6421 7.05662 25.5156 7.05662C24.7527 7.05662 24.0164 7.17097 23.3231 7.38347C24.8408 4.06924 29.3998 1.11247 31.6028 6.47288e-05C20.0908 2.26924 17.7663 10.4466 18.043 14.2516L18.0492 14.2439Z",
                                                                                        fill: "#FDAF4D"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: slide?.testimonial?.message
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                className: "mb-0",
                                                                                children: slide?.testimonial?.name
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: (TechTestimonial_module_default()).addre,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: slide?.testimonial?.details
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: slide?.testimonial?.subDetails
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }, index);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (TechTestimonial_module_default()).arrowsClass,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (TechTestimonial_module_default()).btcircle,
                                                    onClick: ()=>sliderRef?.current?.slickPrev(),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: "/new-images/right-arrow.svg",
                                                        height: 17,
                                                        width: 10,
                                                        alt: "right-arrow"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (TechTestimonial_module_default()).btcircle,
                                                    onClick: ()=>sliderRef?.current?.slickNext(),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: "/new-images/left-arrow.svg",
                                                        height: 17,
                                                        width: 10,
                                                        alt: "left-arrow"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ var TectAtKcTestimonial = (TechTestimonial);

// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 7 modules
var react_select_esm = __webpack_require__(15707);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./components/KcNews.tsx
var KcNews = __webpack_require__(52201);
;// CONCATENATED MODULE: ./components/Career/CustomGalleryCard.tsx



const CustomGalleryCard = ({ bgColor , title , titleColor , subTitle  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (careerkc_module_default()).customCard,
        style: {
            backgroundColor: bgColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                style: {
                    color: titleColor
                },
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: subTitle
            })
        ]
    });
};
/* harmony default export */ var Career_CustomGalleryCard = (CustomGalleryCard);

// EXTERNAL MODULE: ./components/PST/VideoTestimonials.tsx
var VideoTestimonials = __webpack_require__(55689);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Ratio.js
var Ratio = __webpack_require__(84883);
// EXTERNAL MODULE: ./components/LazyMedia/index.tsx
var LazyMedia = __webpack_require__(37462);
;// CONCATENATED MODULE: ./components/Careers.tsx





















const Careerkc = (props)=>{
    const ref = (0,react.useRef)(null);
    const handleButtonClick = ()=>{
        const target = ref.current;
        if (!target) return;
        const start = performance.now();
        const correctionWindowMs = 1500;
        const align = ()=>{
            target.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
            if (performance.now() - start < correctionWindowMs) {
                setTimeout(align, 150);
            }
        };
        align();
    };
    const careerPageData = props?.pageData;
    const { 0: jobLocation , 1: setJobLocation  } = (0,react.useState)("All");
    const { 0: jobCategory , 1: setJobCategory  } = (0,react.useState)("All Jobs");
    const { 0: selectedJobs , 1: setSelectedJobs  } = (0,react.useState)([]);
    const { 0: totalJobs , 1: setTotalJobs  } = (0,react.useState)([]);
    const { 0: searchFilter , 1: setSearchFilter  } = (0,react.useState)("");
    const { 0: searchKeyword , 1: setSearchKeyword  } = (0,react.useState)("");
    const debounceSearchQuery = (searchKeyValue)=>{
        const search = debounce_default()(()=>setSearchFilter(searchKeyValue), 500);
        search();
    };
    const bannerSliderSettings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 2000,
        cssEase: "linear"
    };
    const gallerySettings = {
        dotsClass: (careerkc_module_default()).sliderDots,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        variableWidth: true,
        centerMode: true,
        initialSlide: 1
    };
    const mobileGallerySettings = {
        dotsClass: [
            (careerkc_module_default()).sliderDots,
            (careerkc_module_default()).mobileDots
        ].join(" "),
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
        centerPadding: "60px",
        variableWidth: true
    };
    const coreValueMobileSliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1.2,
        slidesToScroll: 1,
        arrows: false,
        className: "center",
        centerMode: true
    };
    (0,react.useEffect)(()=>{
        const jobs = [];
        careerPageData.jobOpenings.forEach((jobOpening)=>{
            jobs.push(...jobOpening.jobs?.map((job)=>{
                job.category = jobOpening.category;
                return job;
            }));
        });
        setTotalJobs(jobs);
    }, []);
    (0,react.useEffect)(()=>{
        const searchCondition = !searchFilter;
        const categoryCondition = jobCategory === "All Jobs" ? true : false;
        const locationCondition = jobLocation === "All" ? true : false;
        setSelectedJobs(totalJobs.filter((job)=>(job.category === jobCategory || categoryCondition) && (job.jobLocation?.includes(jobLocation) || locationCondition) && (job.jobTitle.toLowerCase().includes(searchFilter.toLocaleLowerCase()) || searchCondition)));
    }, [
        searchFilter,
        jobCategory,
        jobLocation,
        totalJobs
    ]);
    const gallerySliderImages = careerPageData.cultureGallerySection?.gallerySliderImages;
    const galleryImages = gallerySliderImages.reduce((acc, obj, index)=>{
        if ((index + 1) % 3 === 0) {
            acc.push([
                obj
            ]);
        } else {
            if ((index + 1) % 3 === 1) {
                acc[acc.length] = [];
            }
            acc[acc.length - 1].push(obj);
        }
        return acc;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "banner",
                className: (careerkc_module_default()).bannerSection,
                style: {
                    backgroundColor: careerPageData.bannerSection?.sectionBgColor || "#6C48F0"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                        ...bannerSliderSettings,
                        className: "d-none d-sm-block",
                        children: careerPageData.bannerSection?.desktopBannerImages?.length > 0 && careerPageData.bannerSection?.desktopBannerImages?.map((desktopBanner, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (careerkc_module_default()).bannerSlider,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: desktopBanner.url,
                                    "object-fit": "cover",
                                    layout: "responsive",
                                    "object-position": "center",
                                    alt: desktopBanner.alternativeText,
                                    width: 1920,
                                    height: 830,
                                    className: `${(careerkc_module_default()).sliderImage} fill`
                                })
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                        ...bannerSliderSettings,
                        className: "d-block d-sm-none",
                        children: careerPageData.bannerSection?.mobileBannerImages?.length > 0 && careerPageData.bannerSection?.mobileBannerImages?.map((mobielBanner, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (careerkc_module_default()).sliderDiv,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: mobielBanner.url,
                                    "object-fit": "cover",
                                    layout: "responsive",
                                    "object-position": "center",
                                    alt: mobielBanner?.alternativeText,
                                    width: 400,
                                    height: 550,
                                    className: `${(careerkc_module_default()).sliderImage} fill`
                                })
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        id: "edu-expo-box",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (careerkc_module_default()).bannerContent,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    lg: 12,
                                    md: 12,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (careerkc_module_default()).heading,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                style: {
                                                                    opacity: 0.5
                                                                },
                                                                href: "/",
                                                                children: "Home"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                href: "",
                                                                children: " Careers "
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (careerkc_module_default()).content,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (careerkc_module_default()).bannerHeading,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                                        style: {
                                                                            color: careerPageData.bannerSection?.titleOneColor
                                                                        },
                                                                        children: [
                                                                            careerPageData.bannerSection?.titleOne,
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                style: {
                                                                                    color: careerPageData.bannerSection?.titleTwoColor
                                                                                },
                                                                                children: careerPageData.bannerSection?.titleTow
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: careerPageData.bannerSection?.subTitle
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                        className: (careerkc_module_default()).jobOpening,
                                                                        onClick: handleButtonClick,
                                                                        children: "View Job Openings"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: `d-none d-sm-block ${(careerkc_module_default()).fadeContent}`,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                                    className: (careerkc_module_default()).bgHeading,
                                                                    children: [
                                                                        careerPageData.bannerSection?.titleOne,
                                                                        " ",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: careerPageData.bannerSection?.titleTow
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "whoWeAre",
                className: (careerkc_module_default()).whoWeAre,
                style: {
                    backgroundColor: careerPageData.whoWeAre?.sectionBgColor || "#6C48F0"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (careerkc_module_default()).customContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "justify-content-center text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xl: 8,
                                    lg: 8,
                                    md: 8,
                                    sm: 12,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (careerkc_module_default()).whoWeAreContent,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: careerPageData.whoWeAre?.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: careerPageData.whoWeAre?.description
                                                }
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "justify-content-center text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 12,
                                    className: "text-center position-relative",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (careerkc_module_default()).videoPanel,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (careerkc_module_default()).videoBase
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (careerkc_module_default()).videoPlaceholder,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Ratio/* default */.Z, {
                                                    aspectRatio: "16x9",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMedia/* default */.Z, {
                                                        tag: "embed",
                                                        type: "image/svg+xml",
                                                        src: careerPageData?.videoLink
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (careerkc_module_default()).howWeStarted,
                style: {
                    backgroundColor: careerPageData.howWeStarted?.sectionBgColor || "#6C48F0"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (careerkc_module_default()).customContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: careerPageData.howWeStarted?.details?.length && careerPageData.howWeStarted?.details?.map((data, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (careerkc_module_default()).details,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    className: `${index % 2 !== 0 ? (careerkc_module_default()).rowRev : ""}`,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xl: 6,
                                            lg: 6,
                                            md: 12,
                                            sm: 12,
                                            xs: 12,
                                            className: "text-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: `${(careerkc_module_default()).imageBox} ${index % 2 === 0 ? (careerkc_module_default()).leftBox : (careerkc_module_default()).rightBox}`,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (careerkc_module_default()).desktopImage,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: data.image?.url,
                                                            alt: data.image?.alternativeText,
                                                            layout: "responsive",
                                                            width: 500,
                                                            height: 600
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (careerkc_module_default()).mobileImage,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: data.mobileImage?.url,
                                                            alt: data.mobileImage?.alternativeText,
                                                            layout: "responsive",
                                                            width: 330,
                                                            height: 335
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xl: 6,
                                            lg: 6,
                                            md: 12,
                                            sm: 12,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: `${(careerkc_module_default()).content} ${index % 2 === 0 ? (careerkc_module_default()).firstContent : ""}`,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        children: data.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: data.description
                                                        }
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }, index);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (careerkc_module_default()).coreValues,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (careerkc_module_default()).customContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "justify-content-center text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xl: 8,
                                    lg: 8,
                                    md: 8,
                                    sm: 12,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (careerkc_module_default()).hedaingDiv,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: careerPageData.coreValues?.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: careerPageData.coreValues?.description
                                                }
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-none d-sm-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    className: "justify-content-center",
                                    children: careerPageData.coreValues?.valueDetails?.length > 0 && careerPageData.coreValues?.valueDetails.map((valuesData, index)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xl: 3,
                                            lg: 3,
                                            md: 6,
                                            sm: 12,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                                className: (careerkc_module_default()).card,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (careerkc_module_default()).cirlce,
                                                        style: {
                                                            backgroundColor: valuesData.bgColor
                                                        },
                                                        children: [
                                                            " ",
                                                            valuesData.label,
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (careerkc_module_default()).text,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: valuesData.value
                                                        })
                                                    })
                                                ]
                                            })
                                        }, index);
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-block d-sm-none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                fluid: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                        ...coreValueMobileSliderSettings,
                                        className: (careerkc_module_default()).coreValueMobileSlider,
                                        children: careerPageData.coreValues?.valueDetails?.length > 0 && careerPageData.coreValues?.valueDetails.map((valuesData, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                                    className: (careerkc_module_default()).card,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (careerkc_module_default()).cirlce,
                                                            style: {
                                                                backgroundColor: valuesData.bgColor
                                                            },
                                                            children: [
                                                                " ",
                                                                valuesData.label,
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (careerkc_module_default()).text,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: valuesData.value
                                                            })
                                                        })
                                                    ]
                                                })
                                            }, index);
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (careerkc_module_default()).opportunities,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (careerkc_module_default()).customContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (careerkc_module_default()).flexDiv,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (careerkc_module_default()).explore,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: careerPageData.opportunities?.subtitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: careerPageData.opportunities?.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: careerPageData.opportunities?.applyNowLink,
                                            className: (careerkc_module_default()).applyNow,
                                            children: "Visit coursefinder.ai"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (careerkc_module_default()).exploreImage,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: careerPageData.opportunities?.image?.url,
                                        alt: careerPageData.opportunities?.image?.alternativeText,
                                        objectFit: "cover",
                                        width: 622,
                                        height: 413
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (careerkc_module_default()).perksBenefits,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (careerkc_module_default()).customContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "text-left",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (careerkc_module_default()).heading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: careerPageData.perkBenefits?.title
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: careerPageData.perkBenefits?.benefitDetails.length > 0 && careerPageData.perkBenefits?.benefitDetails.map((details, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xs: 6,
                                        xl: 4,
                                        lg: 4,
                                        md: 4,
                                        sm: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (careerkc_module_default()).benefitsDetails,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (careerkc_module_default()).image,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: details.iconImage?.url,
                                                        alt: details.iconImage?.alternativeText,
                                                        width: 100,
                                                        height: 100
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: details.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: details.description
                                                    }
                                                })
                                            ]
                                        })
                                    }, index);
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (careerkc_module_default()).joinUs,
                style: {
                    backgroundColor: careerPageData.cultureGallerySection?.sectionBgColor
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (careerkc_module_default()).customContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (careerkc_module_default()).heading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: careerPageData.cultureGallerySection?.title
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `${(careerkc_module_default()).joinUsSlider} d-none d-sm-block`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                    ...gallerySettings,
                    className: (careerkc_module_default()).gallerySlider,
                    children: galleryImages.length > 0 && galleryImages.map((set, index)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: index % 2 === 0 ? (careerkc_module_default()).column1 : (careerkc_module_default()).column2,
                            children: set.length > 0 && set.map((item, itemIndex)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: item.image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: `${(careerkc_module_default()).img} ${(index + 1) % 4 === 0 ? (careerkc_module_default()).largeSliderImage : ""}`,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: item.image?.url,
                                            alt: item.image?.alternativeText || "",
                                            width: index + 1 % 4 === 0 ? 620 : 300,
                                            height: index % 2 === 0 ? 200 : 420,
                                            objectFit: "fill"
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (careerkc_module_default()).card,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Career_CustomGalleryCard, {
                                                bgColor: item.cardBgColor,
                                                title: item.title,
                                                titleColor: item.titleColor,
                                                subTitle: item.subTitle
                                            }),
                                            " "
                                        ]
                                    })
                                }, itemIndex);
                            })
                        }, index);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `${(careerkc_module_default()).joinUsSlider} d-block d-sm-none`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                    ...mobileGallerySettings,
                    className: (careerkc_module_default()).gallerySlider,
                    children: galleryImages.length > 0 && galleryImages.map((set, index)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: index % 2 === 0 ? (careerkc_module_default()).mobileColumn1 : (careerkc_module_default()).mobileColumn2,
                            children: set.length > 0 && set.map((item, itemIndex)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: item.image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: `${(careerkc_module_default()).img} ${(index + 1) % 4 === 0 ? (careerkc_module_default()).largeSliderImage : ""}`,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: item.image?.url,
                                            alt: item.image?.alternativeText || "",
                                            width: index + 1 % 4 === 0 ? 442 : 214,
                                            height: index % 2 === 0 ? 142 : 300,
                                            objectFit: "cover"
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (careerkc_module_default()).card,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Career_CustomGalleryCard, {
                                                bgColor: item.cardBgColor,
                                                title: item.title,
                                                titleColor: item.titleColor,
                                                subTitle: item.subTitle
                                            }),
                                            " "
                                        ]
                                    })
                                }, itemIndex);
                            })
                        }, index);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (careerkc_module_default()).videoTestimonial,
                children: props.pageData.videoTestimonial && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoTestimonials/* default */.Z, {
                    ...props.pageData.videoTestimonial
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref,
                className: (careerkc_module_default()).jobOpenings,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (careerkc_module_default()).customContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "justify-content-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xl: 12,
                                    lg: 12,
                                    md: 12,
                                    sm: 12,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                        className: (careerkc_module_default()).paddingClass,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                                className: (careerkc_module_default()).locationCategory,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                        xl: 6,
                                                        md: 6,
                                                        lg: 6,
                                                        xs: 12,
                                                        sm: 12,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            children: "Current Job Openings"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                        xl: 6,
                                                        md: 6,
                                                        lg: 6,
                                                        xs: 12,
                                                        sm: 12,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                                            className: "justify-content-end",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                                                    xl: 6,
                                                                    md: 12,
                                                                    lg: 6,
                                                                    xs: 12,
                                                                    sm: 12,
                                                                    className: (careerkc_module_default()).softCatgory,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: `${(careerkc_module_default()).searchLabel} ${(careerkc_module_default()).locationLable}`,
                                                                            children: "Location:"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                                                                            placeholder: jobLocation || "Select Location",
                                                                            value: jobLocation,
                                                                            className: (careerkc_module_default()).customSelect,
                                                                            classNamePrefix: "careersPageSelect",
                                                                            options: [
                                                                                {
                                                                                    value: "All",
                                                                                    label: "All"
                                                                                },
                                                                                ...careerPageData.locations?.map((location)=>({
                                                                                        label: location.location,
                                                                                        value: location.location
                                                                                    })), 
                                                                            ],
                                                                            onChange: (selectedLocationOption)=>setJobLocation(selectedLocationOption.value)
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                    xl: 6,
                                                                    md: 12,
                                                                    lg: 6,
                                                                    xs: 12,
                                                                    sm: 12,
                                                                    className: (careerkc_module_default()).searchAlign,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                                                        className: "navbar-form",
                                                                        role: "search",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "input-group add-on",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: (careerkc_module_default()).inputBox,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                        className: "form-control",
                                                                                        placeholder: "Search Job",
                                                                                        name: "srch-term",
                                                                                        id: "srch-term",
                                                                                        type: "text",
                                                                                        onChange: (e)=>{
                                                                                            setSearchKeyword(e.target.value);
                                                                                            debounceSearchQuery(searchKeyword);
                                                                                        },
                                                                                        value: searchKeyword
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: (careerkc_module_default()).inputBtn,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                            src: "/careersearchicon.svg",
                                                                                            alt: "searchco",
                                                                                            width: 14,
                                                                                            height: 14,
                                                                                            onClick: ()=>debounceSearchQuery(searchKeyword)
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                                    className: `${(careerkc_module_default()).searchLabel} ${(careerkc_module_default()).allJobs}`,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                onClick: (event)=>{
                                                                    setJobCategory(event.target.innerText);
                                                                },
                                                                className: jobCategory === "All Jobs" ? (careerkc_module_default()).active : "",
                                                                children: "All Jobs"
                                                            })
                                                        }),
                                                        careerPageData.jobOpenings?.map((openings, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    onClick: (event)=>{
                                                                        setJobCategory(event.target.innerText);
                                                                    },
                                                                    className: jobCategory === openings.category ? (careerkc_module_default()).active : "",
                                                                    children: openings.category
                                                                })
                                                            }, index))
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (careerkc_module_default()).border
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "justify-content-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xl: 12,
                                    lg: 12,
                                    md: 12,
                                    sm: 12,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                            className: "justify-content-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xl: 12,
                                                lg: 12,
                                                xs: 12,
                                                md: 12,
                                                sm: 12,
                                                className: "p-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                    children: selectedJobs?.length > 0 && selectedJobs.map((job, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                            xl: 4,
                                                            lg: 4,
                                                            md: 6,
                                                            xs: 12,
                                                            sm: 12,
                                                            className: (careerkc_module_default()).cardsMain,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: job.jobLink,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (careerkc_module_default()).cardCareer,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                            children: job.jobTitle
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (careerkc_module_default()).jobLocation,
                                                                            children: job.jobLocation
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }, index))
                                                }, searchFilter)
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TectAtKcTestimonial, {
                    title: "What Our Team Feels",
                    bgColor: "#DBE8FF",
                    slug: `testimonials?type=employee&_sort=priority:ASC`
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (careerkc_module_default()).kctechnews,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KcNews["default"], {
                    ...props
                })
            })
        ]
    });
};
/* harmony default export */ var Careers = (Careerkc);

// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
;// CONCATENATED MODULE: ./pages/careers.tsx




const CareerKC = (props)=>{
    const { meta  } = props.pageData;
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#1e1553e3");
        customStyle.setProperty("--navbar-menu-color", "#ffffff");
        customStyle.setProperty("--top-margin", "0");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...meta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Careers, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var careers = (CareerKC);


/***/ }),

/***/ 40607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const DEFAULT_TIMEOUT_MS = 8000;
const fetchUtil = async (url, method, body, ctype, useToken, useHeaders, token, timeoutMs = DEFAULT_TIMEOUT_MS)=>{
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(), timeoutMs);
    let options = {};
    if (method === "GET") {
        options = useHeaders ? {
            method,
            signal: controller.signal
        } : {
            method,
            headers: requestHeaders(ctype, useToken, token),
            signal: controller.signal
        };
    } else {
        options = {
            method,
            headers: requestHeaders(ctype, useToken, token),
            body: JSON.stringify(body),
            signal: controller.signal
        };
    }
    try {
        const res = await fetch(url, options);
        return await parseStatus(res.status, res);
    } finally{
        clearTimeout(timer);
    }
};
const parseStatus = (status, res)=>{
    return new Promise((resolve, reject)=>{
        if (status >= 200 && status < 300) {
            if (res.url.indexOf(".html") > -1) {
                return resolve(res);
            }
            res.json().then((response)=>resolve(response));
        } else {
            res.json().then((response)=>reject(response));
        }
    });
};
const requestHeaders = (ctype, useToken, token)=>{
    return useToken ? {
        "Content-Type": ctype || "application/json",
        Authorization: token
    } : {
        "Content-Type": ctype || "application/json"
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (fetchUtil);


/***/ }),

/***/ 81673:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dynamicBg":"Home_dynamicBg__Oa7bk","mainSectionBg":"Home_mainSectionBg__A9gt6","mobileImgHeight":"Home_mobileImgHeight__Z60sQ","mainContent":"Home_mainContent__xRNLb","contentImgGirl":"Home_contentImgGirl__1cf3x","mainSectionBgBgImage":"Home_mainSectionBgBgImage__DnwAr","Strengths":"Home_Strengths__RKsxE","StrengthsContent":"Home_StrengthsContent__XQ7o6","multiCountry":"Home_multiCountry__qnPs4","multi_country_content":"Home_multi_country_content__IpYuO","viewMore":"Home_viewMore__QL5Gu","WebinarHomeLineImg":"Home_WebinarHomeLineImg__QylnF","home_page_service_div":"Home_home_page_service_div__abSpF","serviceHead":"Home_serviceHead__nke_6","service_content":"Home_service_content__u0y6f","serviceAnchor":"Home_serviceAnchor__VYwFg","service_img_slider":"Home_service_img_slider__Cfgv3","webinarEventsMianSection":"Home_webinarEventsMianSection__w5oOf","homePageKcOnlinePlatform":"Home_homePageKcOnlinePlatform__Jqify","KCOnlinePlatroms":"Home_KCOnlinePlatroms__glDmw","centered":"Home_centered___f9pj","PlatformContent":"Home_PlatformContent__01JL5","platformDivImg":"Home_platformDivImg__qhEjG","platformDivImgMobile":"Home_platformDivImgMobile__p9Qyz","uniTieUp":"Home_uniTieUp__dI5K3","cols":"Home_cols__z_McS","borderl0":"Home_borderl0__qYIXO","border0":"Home_border0__rUKqg","homepageUniTieUp":"Home_homepageUniTieUp__AEIhQ","homePageLatestKcUpdates":"Home_homePageLatestKcUpdates__lEY82","homePageBlogs":"Home_homePageBlogs__IOfQB","sliderDots":"Home_sliderDots__TrjVn","slick-slide":"Home_slick-slide__rPyO0","slider":"Home_slider__SoxcW","homekcNewLatestUpdate":"Home_homekcNewLatestUpdate__BJXyc","arrowsClass":"Home_arrowsClass__JqIvl","kcNews":"Home_kcNews__rqDUy","heading":"Home_heading__5g6vc","col":"Home_col__iXDGx","borderBottomMd":"Home_borderBottomMd__aPuuu","borderBottomSm":"Home_borderBottomSm__8Df4_","borderBottomXs":"Home_borderBottomXs__HmA_i","kcNewsSliderDots":"Home_kcNewsSliderDots__q8A_R","heroImageWrapper":"Home_heroImageWrapper__kLwo_","responsiveHeroImage":"Home_responsiveHeroImage__aeR_X"};

/***/ }),

/***/ 12776:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"studentServicesPage":"TechTestimonial_studentServicesPage__TJa7D","studentServicesCurve":"TechTestimonial_studentServicesCurve__Cx2LS","contentDiv":"TechTestimonial_contentDiv___RNta","enquirebtn":"TechTestimonial_enquirebtn__f6LuM","servContent":"TechTestimonial_servContent__geUso","WhyKc":"TechTestimonial_WhyKc__h4ufO","viewMore":"TechTestimonial_viewMore__t_WLC","img":"TechTestimonial_img__rYawb","studentServicesWebinarEvent":"TechTestimonial_studentServicesWebinarEvent__xWsqK","studentHelpMainDiv":"TechTestimonial_studentHelpMainDiv__9CiLN","studentHelp":"TechTestimonial_studentHelp__oknOk","alignTop":"TechTestimonial_alignTop__WYffU","subAnchor":"TechTestimonial_subAnchor__21DVL","knowMore":"TechTestimonial_knowMore__hZcIx","linksDiv":"TechTestimonial_linksDiv__oQEYn","studentServicesKcUpdates":"TechTestimonial_studentServicesKcUpdates__F0UVH","StudentBlogs":"TechTestimonial_StudentBlogs__XxR69","studentFooter":"TechTestimonial_studentFooter__S_pEc","session":"TechTestimonial_session__niHCf","student":"TechTestimonial_student__uSj9v","middelStuTest":"TechTestimonial_middelStuTest__S8QPS","overlay":"TechTestimonial_overlay__ajn37","stuTestCard":"TechTestimonial_stuTestCard__2gyah","cardBody":"TechTestimonial_cardBody__bX6hz","addre":"TechTestimonial_addre__GV_nv","testimonialImage":"TechTestimonial_testimonialImage__3zrjl","testimonialDetail":"TechTestimonial_testimonialDetail__4MRqx","customContainer":"TechTestimonial_customContainer__P4XcI","studentTestSlider":"TechTestimonial_studentTestSlider__yoAtU","sevenBG":"TechTestimonial_sevenBG__08E07","sliderDots":"TechTestimonial_sliderDots__wkfu6","arrowsClass":"TechTestimonial_arrowsClass__7kHOu","btcircle":"TechTestimonial_btcircle__Kejf0","arrowsClasses":"TechTestimonial_arrowsClasses__qRuDN"};

/***/ }),

/***/ 46577:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"css-1okebmr-indicatorSeparator":"careerkc_css-1okebmr-indicatorSeparator__0DwCH","bannerSection":"careerkc_bannerSection__JRki3","bannerSlider":"careerkc_bannerSlider___Hfjq","sliderDiv":"careerkc_sliderDiv__jqJFK","bannerContent":"careerkc_bannerContent__UG1tq","heading":"careerkc_heading__BdtKW","content":"careerkc_content__7DbYX","bannerHeading":"careerkc_bannerHeading__ainLb","jobOpening":"careerkc_jobOpening__TPDOc","fadeContent":"careerkc_fadeContent__W153Q","bgHeading":"careerkc_bgHeading__6D4Ug","whoWeAre":"careerkc_whoWeAre__MnZwS","image":"careerkc_image__netvB","videoPanel":"careerkc_videoPanel__goISk","videoBase":"careerkc_videoBase__dGiwP","videoPlaceholder":"careerkc_videoPlaceholder__GK6SO","customContainer":"careerkc_customContainer__Fl3yu","howWeStarted":"careerkc_howWeStarted__bCo4H","details":"careerkc_details__Gyh4S","rowRev":"careerkc_rowRev__6capk","imageBox":"careerkc_imageBox__9rv21","desktopImage":"careerkc_desktopImage__27XfT","mobileImage":"careerkc_mobileImage__Cn1fF","leftBox":"careerkc_leftBox__m2m7Z","rightBox":"careerkc_rightBox__33jeO","firstContent":"careerkc_firstContent__uLH_i","coreValues":"careerkc_coreValues__ydUo8","hedaingDiv":"careerkc_hedaingDiv__Th94E","card":"careerkc_card__TwnIP","cirlce":"careerkc_cirlce__eNb1e","text":"careerkc_text__LVeXZ","coreValueMobileSlider":"careerkc_coreValueMobileSlider__1a5hF","opportunities":"careerkc_opportunities__3vaK6","flexDiv":"careerkc_flexDiv__AzEMN","explore":"careerkc_explore__mOiw_","exploreImage":"careerkc_exploreImage___7U_s","applyNow":"careerkc_applyNow__TNxI_","perksBenefits":"careerkc_perksBenefits__Ah3UE","benefitsDetails":"careerkc_benefitsDetails__V85En","joinUs":"careerkc_joinUs__W5bEN","joinUsSlider":"careerkc_joinUsSlider__WlNM_","evenSlider":"careerkc_evenSlider__lNAeI","oddSlider":"careerkc_oddSlider__gGkEW","oddBox":"careerkc_oddBox__nEFVK","gallerySlider":"careerkc_gallerySlider__rpG0g","customCard":"careerkc_customCard__uDh6T","column2":"careerkc_column2__ioxh5","img":"careerkc_img__maJcs","largeSliderImage":"careerkc_largeSliderImage__FdRoO","column1":"careerkc_column1__S7sWd","mobileColumn1":"careerkc_mobileColumn1__eq_US","mobileColumn2":"careerkc_mobileColumn2__ONn1W","sliderDots":"careerkc_sliderDots__IPvQZ","slick-active":"careerkc_slick-active__WggVH","mobileDots":"careerkc_mobileDots__kwYcq","jobOpenings":"careerkc_jobOpenings__WacOu","locationLable":"careerkc_locationLable__Q_QMQ","mySelect__input-container":"careerkc_mySelect__input-container__oQ_vM","searchLabel":"careerkc_searchLabel__6Rcfn","allJobs":"careerkc_allJobs__WvQPD","cardsMain":"careerkc_cardsMain__SCo0c","cardCareer":"careerkc_cardCareer__gvvKf","jobLocation":"careerkc_jobLocation__9nKeA","linkArrow":"careerkc_linkArrow__MTB5k","softCatgory":"careerkc_softCatgory__3Qcgu","customSelect":"careerkc_customSelect___Zo1r","searchAlign":"careerkc_searchAlign__k5QEB","categoryTitle":"careerkc_categoryTitle__QfhgF","active":"careerkc_active__ifSEZ","head":"careerkc_head__ryHjA","paddingClass":"careerkc_paddingClass__UDws1","border":"careerkc_border__drXX1","inputBox":"careerkc_inputBox__AjPAz","input":"careerkc_input__5PjyM","inputBtn":"careerkc_inputBtn__mX2We","videoTestimonial":"careerkc_videoTestimonial__ZDNHh"};

/***/ }),

/***/ 42547:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"pstlandingpage_banner__g_UPf","nav":"pstlandingpage_nav__QrKZh","navLogo":"pstlandingpage_navLogo__rYw7Z","maincontent":"pstlandingpage_maincontent__tcl1X","fairdetails":"pstlandingpage_fairdetails___3Awg","heading":"pstlandingpage_heading__CmSZI","ulli":"pstlandingpage_ulli__fqPBp","liItem":"pstlandingpage_liItem__kE_QJ","regBtn":"pstlandingpage_regBtn__SXSXv","reg":"pstlandingpage_reg__808jO","enq":"pstlandingpage_enq__YbXM2","btnReg":"pstlandingpage_btnReg__ifx_Y","bannerStudDiv":"pstlandingpage_bannerStudDiv__h0Iis","bg":"pstlandingpage_bg__EOIvU","WhyKc":"pstlandingpage_WhyKc__aTj1F","viewMore":"pstlandingpage_viewMore__57U7q","whyMb":"pstlandingpage_whyMb__E2tnD","bussiness":"pstlandingpage_bussiness__8M5jS","uni":"pstlandingpage_uni__iGGja","img":"pstlandingpage_img__zoQjU","logo":"pstlandingpage_logo__PhEVL","sliderdiv":"pstlandingpage_sliderdiv__WSqCW","capabilityBg":"pstlandingpage_capabilityBg__e8FfP","content":"pstlandingpage_content__Lr07i","subcontent":"pstlandingpage_subcontent__bduG9","imgRow":"pstlandingpage_imgRow__5PEei","steps":"pstlandingpage_steps__uo121","points":"pstlandingpage_points__Qc5ZJ","mainbox":"pstlandingpage_mainbox__2nHev","boximg":"pstlandingpage_boximg___iqhq","association":"pstlandingpage_association__KcsWN","custCard":"pstlandingpage_custCard__2dOTw","imgDiv":"pstlandingpage_imgDiv__zKq9h","cardBody":"pstlandingpage_cardBody__5VPch","mainDiv":"pstlandingpage_mainDiv__E_si7","div":"pstlandingpage_div__12NSx","footer":"pstlandingpage_footer__UMKA1","footerlogo":"pstlandingpage_footerlogo__r5ngN","activeClass":"pstlandingpage_activeClass__XLLQe","arrowsClass":"pstlandingpage_arrowsClass___Haw3","btcircle":"pstlandingpage_btcircle__Sy1vj","sliderDots":"pstlandingpage_sliderDots__f2brx","elanLoansComp":"pstlandingpage_elanLoansComp__Xu5qO","elanContent":"pstlandingpage_elanContent__a4FxP","elanSubheading":"pstlandingpage_elanSubheading__MZ9zo","slider":"pstlandingpage_slider__ux_j6","imageDiv":"pstlandingpage_imageDiv__zXYkn","countryName":"pstlandingpage_countryName__y5U_f","button":"pstlandingpage_button__Hj8FU","enquirebtn":"pstlandingpage_enquirebtn__HXtlR","achievements":"pstlandingpage_achievements__4uMWW","description":"pstlandingpage_description__9Po_q","containerDiv":"pstlandingpage_containerDiv__1iO_z","sliderContainer":"pstlandingpage_sliderContainer__BD5UY","achievementsDiv":"pstlandingpage_achievementsDiv__gDUMc","icon":"pstlandingpage_icon__6cN3s","studVideo":"pstlandingpage_studVideo__57n8X","videoDiv":"pstlandingpage_videoDiv__gcrFA","videos":"pstlandingpage_videos__mNRB3","faqComponent":"pstlandingpage_faqComponent__DG96z","box":"pstlandingpage_box__dSteF","stuAccordion":"pstlandingpage_stuAccordion__0Carb","accoHead":"pstlandingpage_accoHead__5gc_W","card":"pstlandingpage_card___j1YG","cardImgDiv":"pstlandingpage_cardImgDiv__ANALH","cardImg":"pstlandingpage_cardImg__n_32_","caption":"pstlandingpage_caption___TAdQ","caption2":"pstlandingpage_caption2__V6haF","localeButton":"pstlandingpage_localeButton__N8bhp","selectClass":"pstlandingpage_selectClass__l1KDY"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,5707,6410,474,9774,2888,179], function() { return __webpack_exec__(3137); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);